import React from "react";
import {
  Switch,
  Route,
  HashRouter,
  useRouteMatch,
  Redirect,
} from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { AuthLayout } from "./Layout/authLayout";
import { Layout } from "./Layout/metronicLayout";
import Login from "./Pages/Auth/Login";
import ForgotPassword from "./Pages/Auth/ForgotPassword";
// import ResetPassword from "./Pages/Auth/ResetPassword";
import { Dashboard } from "./Pages/Dashboard/Dashboard";
import { routers } from "./Constants/router_paths";
import { OrganizationPage } from "./Pages/Organizations/OrganizationsPage";
import { ClientProfile } from "./Pages/ClientProfile/ClientProfile";
import ReportingOverview from "./Layout/ReportOverview";
import ReportingOverviewCoaches from "./Layout/coachesFilter/reportOverview";
import ReportCoach from "./Layout/coachesFilter/Choches";
import ReportOverviewJobskeer from "./Layout/ReportOverview";
import JobSeeker from "./Layout/Job_Seeker";
import Programs from "./Pages/Programs";
import AddProgram from "./Pages/Programs/AddProgram";
import EditProgram from "./Pages/Programs/EditProgram";
import ResetPassword from "./Pages/Auth/ResetPassword";

export function Routes() {
  const { accessToken, ...user } = useSelector(
    ({ auth }) => auth,
    shallowEqual
  );
  const isAuthorized = !!accessToken;
  console.log("************");
  console.log(isAuthorized);

  React.useEffect(() => {
    console.log(user, "test");
  }, [accessToken]);

  return (
    <HashRouter>
      <Switch>
        {!isAuthorized ? (
          <Route path="/auth">
            <AuthRoutes />
          </Route>
        ) : (
          <Redirect from="/auth" to="/" />
        )}
        {isAuthorized ? <AuthorizedRoutes /> : <Redirect to="/auth/login" />}
      </Switch>
    </HashRouter>
  );
}

function AuthRoutes() {
  let { path } = useRouteMatch();

  return (
    <AuthLayout>
      <Switch>
        <Route path={`${path}/login`} component={Login} />
        <Route path={`${path}/forgot-password`} component={ForgotPassword} />
        <Route path={`${path}/reset-password`} component={ResetPassword} />
        {/* <Route path={`${path}/reset-password`} component={ResetPassword} /> */}
        <Route path={routers.clientProfile} exact component={ClientProfile} />

      </Switch>
    </AuthLayout>
  );
}

function AuthorizedRoutes() {
  return (
    <Layout>
      <Switch>
        <Route path={"/"} exact component={Dashboard} />
        <Route path={"/dashboard"} exact component={Dashboard} />
        <Route path={"/programs"} exact component={Programs} />
        <Route path="/programs/add-program" exact component={AddProgram} />
        <Route path="/programs/edit-program/:id" exact component={EditProgram} />
        {/* <Route path={"/reportOverview"} exact component={ReportingOverview} /> */}
        {/* <Route path={routers.organizations} component={OrganizationPage} /> */}
        <Route path={routers.clientProfile} component={ClientProfile} />
        <Route
          exact
          path="/reportoverview/coaches"
          component={ReportingOverviewCoaches}
        />
        <Route
          exact
          path="/reportoverview/coaches/report"
          component={ReportCoach}
        />
        <Route
          exact
          path="/reportoverview/coaches/report?id=:id"
          component={ReportCoach}
        />

        <Route
          exact
          path="/reportoverview/job-seeker"
          component={ReportOverviewJobskeer}
        />
        <Route
          exact
          path="/reportoverview/job-seeker/report"
          component={JobSeeker}
        />
        <Route
          exact
          path="/reportoverview/job-seeker/report?id=:id"
          component={JobSeeker}
        />

        <Route path="/reportoverview/job-seeker" component={JobSeeker} />
      </Switch>
    </Layout>
  );
}
